/**
 * react-i18next's `Trans`, safe for content (doc/20261023-i18n-zh-cn.md §3.1). `Trans` interpolates values and then
 * parses the sentence for its components, so a value holding `<b style=…>` (an email subject, a person's name, a
 * term) would become markup, or crash the render. Here values are escaped before the parse and unescaped only in the
 * text nodes it yields: content is always text. Import this `Trans`, never react-i18next's.
 */
import { Trans as I18nextTrans } from 'react-i18next';

/** Typed exactly as react-i18next's own `Trans`, so callers keep its key checking and the compiler infers nothing new. */
export const Trans = ((props: Readonly<Record<string, unknown>> & { readonly tOptions?: { readonly interpolation?: object } }) => (
  <I18nextTrans {...props} shouldUnescape
    tOptions={{ ...props.tOptions, interpolation: { ...props.tOptions?.interpolation, escapeValue: true } }} />
)) as unknown as typeof I18nextTrans;
